import React from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { Truck, FileText, ArrowLeft, FileSpreadsheet } from 'lucide-react';
import { Button } from '@/components/ui/button';

const navItems = [
  { to: '/dispatch', icon: Truck, label: 'Dispatches', end: true },
  { to: '/dispatch/reports', icon: FileSpreadsheet, label: 'Customer Reports' },
];

export default function DispatchLayout() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="sticky top-0 z-30 bg-card border-b px-4 py-2 flex items-center gap-3">
        <Button variant="ghost" size="icon" className="h-8 w-8" onClick={() => navigate('/erp')} data-testid="back-to-erp">
          <ArrowLeft className="w-4 h-4" />
        </Button>
        <div className="flex items-center gap-2">
          <Truck className="w-5 h-5 text-primary" />
          <span className="font-semibold text-sm">Dispatch</span>
        </div>
        <nav className="flex items-center gap-1 ml-4">
          {navItems.map(item => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-medium transition-colors ${
                  isActive ? 'bg-primary text-primary-foreground' : 'text-muted-foreground hover:bg-muted'
                }`
              }
            >
              <item.icon className="w-3.5 h-3.5" />
              {item.label}
            </NavLink>
          ))}
        </nav>
      </header>

      {/* Content */}
      <main className="p-4">
        <Outlet />
      </main>
    </div>
  );
}
